import * as React from "react"
import { cn } from "../../lib/utils"

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

export function Label({ children, className, ...props }: LabelProps) {
  return (
    <label
      className={cn("block text-sm font-medium text-slate-700 mb-2", className)}
      {...props}
    >
      {children}
    </label>
  )
}
